<template>
    <div class="page white_bg">

        <header class="pageHeader paddingH16 white_bg bottomBorderB3B3B3" style="line-height: 46px; ">
            <div class="borderLayout">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <span class="icon leftAngleBracketIcon floatL" style="margin-top: 11px;" @click="back();"></span>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold hiddenOverflow"
                         style="height: 46px; ">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px">

                    </div>
                </div>
            </div>
        </header>

        <div class="body">
            <div style="padding: 32px 14px 26px 23px; " class="bottomBorderB3B3B3">
                <div class="flexLayout">
                    <div style="width: 40px;" :data-userid="dataItem ? dataItem.userInfo.userId : ''">
                        <div class="imageArea" style="height: 40px;" @click="viewUser()">
                            <img class="fullSpace circle" :src="dataItem.userInfo.headerImg"
                                 v-if="dataItem && dataItem.userInfo"/>
                        </div>
                    </div>
                    <div class="flexItem" style="margin-left: 12px;">
                        <span class="f14" @click="viewUser()">{{ dataItem ? dataItem.userInfo.userName : '' }}</span>
                        <span class="color8A8A8A fr f13">{{ dataItem ? formatDelayTime(dataItem.createTime) : '' }}</span>
                        <div class="colorA9ABAE f12">
                            {{ dataItem ? dataItem.userInfo.signature : '' }}
                        </div>
                    </div>
                </div>
                <div class="marginT12 color101010 font14r" style="line-height: 22px;">
                    {{ dataItem ? dataItem.title : '' }}
                </div>
                <div class="marginT8" v-if="dataItem && dataItem.imgList.length">
                    <img :src="dataItem.imgList[0]" style="max-width: 186px; height: auto;" v-gallery="imageGroup" />
                </div>

                <div class="imageContainer2 marginT8 clearfix" :class="{ 'moreThanThree' : dataItem.imgList.length > 3 }"
                     v-if="dataItem && dataItem.imgList.length">
                    <div class="imageItem roundBorder4" v-for="(imageItem, index) in dataItem.imgList" style="height: 113px;">
                        <img class="fullSpace cover" :src="imageItem" v-gallery="imageGroup"/>
                        <div class="imageCaption white alignC" v-if="index == 2 && dataItem.imgList.length > 3">
                            +
                            <strong class="bold font18r">{{ dataItem.imgList.length - 3 }}</strong>
                        </div>
                    </div>
                </div>

                <div class="marginT8 relative" v-if="dataItem && dataItem.videoCover">
                    <img :src="dataItem.videoCover" style="max-width: 100%; height: auto;"/>
                    <div class="playIcon2" style="
                        z-index: 1 ;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        height: 84px;
                        width: 84px;
                        margin-left: -42px;
                        margin-top: -42px;">
                    </div>
                </div>
            </div>

            <div class="clearfix" style="padding: 9px 4px 9px 21px; line-height: 44px;">
                <strong class="floatL orange" style="border-bottom: solid 3px #F7AA01;">全部评论</strong>
                <div class="floatR color838383">
                    <i class="fa fa-sort-amount-desc marginR4"></i>
                    <span>最热</span>
                </div>
            </div>

            <div class="bgF8F8F6 flexLayout" style="padding: 9px 0 9px 17px;">
                <div class="flexItem clearfix">
                    <input class="marginR4 noBorder floatL" type="text" placeholder="评论一下~"
                           style="width: 200px; height: 30px; line-height: 30px; color: #B7B6B6;"
                        v-model="commentArea.content"/>
                    <button class="submitButton icon floatL" type="button" @click="submitComment()"></button>
                </div>
                <div style="width: 68px;">
                    <i class="icon praiseIcon size24" :class="{active : dataItem && dataItem.isPraise}" @click="praise()"></i>
                </div>
            </div>

            <div style="padding: 32px 13px 24px 24px;">
                <div class="color101010 clearfix">
                    全部{{ dataItem ? dataItem.commentCount : '' }}条评论
                    <div class="font14r floatR">
                        {{ dataItem ? dataItem.praiseCount : '' }}赞
                        &gt;
                    </div>
                </div>

                <commentList ref="commentList" :courseVodId="dataItem ? dataItem.id : ''"/>

<!--                <div class="commentList marginT20" style="padding-right: 23px;">-->
<!--                    <div class="commentItem relative" style="padding-bottom: 26px;" v-for="commentItem in commentList"-->
<!--                        :key="commentItem.id">-->
<!--                        &lt;!&ndash; 头像栏 &ndash;&gt;-->
<!--                        <div class="flexLayout">-->
<!--                            <div class="marginR12" style="width: 35px;">-->
<!--                                <div class="imageArea" style="height: 35px;">-->
<!--                                    <img class="fullSpace circle cover" :src="commentItem.userInfo.headerImg"-->
<!--                                        v-if="commentItem.userInfo"/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="flexItem">-->
<!--                                <i class="icon praiseIcon size24" style="position: absolute; z-index: 1;-->
<!--                                    right: 0px; top: 8px;"></i>-->
<!--                                <div class="font14r color101010">{{ commentItem.userInfo.userName }}</div>-->
<!--                                <div class="font12r" style="color: #A9ABAE;">{{ commentItem.userInfo.signature }}</div>-->
<!--                                <div class="marginT12" style="color: #080808;">-->
<!--                                    {{ commentItem.content }}-->
<!--                                </div>-->
<!--                                <div class="marginT12 font14r color101010">-->
<!--                                    <span>回复</span>-->
<!--                                </div>-->
<!--&lt;!&ndash;                                <div class="replyContentContainer relative" v-if="dataItem.replyContext"&ndash;&gt;-->
<!--&lt;!&ndash;                                     style="margin-left:32px; margin-top: 12px;"&ndash;&gt;-->
<!--&lt;!&ndash;                                     :data-replyTime="formatDate(dataItem.replyTime)" :data-replyUserName="dataItem.replyUserName">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="inner lineHeight150p font12r">作者：{{dataItem.replyContext}}</div>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>

        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart   from '@/components/shixunApp/shixunPagePart';
import commentList      from './module/commentList'

// config
import appConfig    from '@/appConfig';
import bizTypeEnum  from "@data/bizTypeEnum";

//
import commentApi   from "./commentApi";
import praiseApi    from '@/api/praise';

// util
import appHelper        from '@/util/appHelper';
import dataMixedUtils   from "@util/dataMixedUtils";
import routeHelper      from "@util/routeHelper";

const config = {
    name : 'informationDetail',
    title : '师圈详情',
    description : '',
    apiConfig : {
        get : {
            url : 'portal/moment/get',
            dataPath : 'data',
        }
    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '今天跟一个HR老友聊天，对方说到：候选人最好不要频繁跳槽，整个职业经历中至少要有一段经历是有3年的。这话不止几个HR跟我们说，很多HR都说过。为什么呢？因为1.频繁的更换环境会造成惯性；2.没有待的'
    ]
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : { commentList },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            enableDataItem : true,
            autoLoadDataItem : true,

            imageGroup : 'imageGroup',

            commentList : [],

            commentArea : {
                content : ''
            }
        }
    },
    methods : {

        onLoadDataItem : function () {
            let appName = appConfig.name || '';

            // this.title = this.dataItem.title;

            // appHelper.setTitle(this.dataItem.title);

            this.setWechatShare();

            this.$refs.commentList.updateDataList({
                bizId : this.dataItem.id
            });
        },
        viewUser() {
            appHelper.goToPage('informationUser', {
                id : this.dataItem.userInfo.userId
            });
        },
        praise() {
            if (this.dataItem.isPraise)
            {
                praiseApi.cancelPraise({
                    bizType : bizTypeEnum.SHIXUN_MOMENT.code,
                    id : this.dataItem.id
                }, () => {
                    appHelper.showHint('取消点赞成功');
                    this.dataItem.isPraise = !this.dataItem.isPraise;
                });
            }
            else
            {
                praiseApi.praise({
                    bizType : bizTypeEnum.SHIXUN_MOMENT.code,
                    id : this.dataItem.id
                }, () => {
                    appHelper.showHint('点赞成功');
                    this.dataItem.isPraise = !this.dataItem.isPraise;
                });
            }
        },
        submitComment() {
            if (this.commentArea.content == '')
            {
                appHelper.showHint('请填写评论内容');
                return;
            }

            const me = this;

            commentApi.submitComment({
                bizId  : this.dataItem.id,
                bizType  : bizTypeEnum.SHIXUN_MOMENT.code,
                content : this.commentArea.content,
            }, () => {
                appHelper.showHint('提交成功');
                me.$refs.commentList.reloadDataList();
            });
        }
    },
    mounted() {

        let id = routeHelper.getParam(this, 'id');
        if (appConfig.mode === 'demo')
        {
            this.dataItem = {
                id : id,
                title : dataMixedUtils.array.getRandomItem(config.demoTitleList),
                coverImg : appHelper.getRandomCoverImage(),
                userInfo: {
                    headerImg: appHelper.getRandomCoverImage(),
                    signature: '杭州创业小公司产品经理',
                    userId: 1,
                    userName: dataMixedUtils.string.getRandomNickName(),
                },
                userImg : appHelper.getRandomCoverImage(),
                userName : dataMixedUtils.string.getRandomNickName(),
                signature : '杭州创业小公司产品经理',
                createTime : new Date().getTime() - dataMixedUtils.number.getRandomInteger(1000 * 60 * 60 * 24 * 7),
                imgList : [],
                type : 0,
                videoCover : '',
                video : null,
                commentCount : dataMixedUtils.number.getRandomInteger(20),
                praise : dataMixedUtils.number.getRandomInteger(200),
            };

            if (dataMixedUtils.number.getRandomInteger(2) == 1)
            {
                this.dataItem.type = 2;
                this.dataItem.videoCover = appHelper.getRandomCoverImage();
            }
            else
            {
                this.dataItem.type = 1;
                this.dataItem.imgList = dataMixedUtils.array.buildDataList(dataMixedUtils.number.getRandomInteger(6), (index) => {
                    return appHelper.getRandomCoverImage();
                });
            }

            this.commentList = dataMixedUtils.array.buildDataList(8, (index) => {
                return {
                    id: index,
                    userInfo: {
                        userId: 1,
                        headerImg: appHelper.getRandomCoverImage(),
                        userName: dataMixedUtils.string.getRandomNickName(),
                        signature: '杭州创业小公司产品经理'
                    },
                    createTime: new Date().getTime() - dataMixedUtils.number.getRandomInteger(1000 * 60 * 60 * 24 * 7),
                    content: 'comment',
                };
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.playIcon2 {
    background-image: url(data:image/png;base64,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)
}
.orange {
    color: #F7AA01;
}
.color838383 {
    color: #838383;
}
.bgF8F8F6 {
    background-color: #F8F8F6;
}
.praiseIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFVUlEQVRoQ+2Za2hbZRjHl/QSrWiztVu3bvOLzPplMFBxMKYi2+iXffGDoqKzINWkbdrazHpDM1GndaZ3O6tClKKDMhQRZN6KDKZDmUwHw32oOG3rZVkaiyUlN39POae8TU4unck5GSxw6M55n/d9/v/n+b/Pe5lt1WX+s13m+FddIWB1BouaAZ/PZ5+dnX0IkpuTyeSv8Xj8+NDQ0C+FJF00Am1tbdvtdvtRm81WrwCOQWSwv7//8UKRKAqBjo4OJ0DPAn59BqAH+vr6fIUgUSwCAu55DaAPIm8jnxv5KxlZDbmFRCKxbnBw8J//S6IoBNrb278G6O2A+55I36qD7Ozs3AX4z+UdAq6BgYHDpUrgHAS2APYT9L5XBYm8pnnfQNs7tD1SqgQiEHAA7gMycL8Kkux8RttuCByDQGPJEaD6bCorK/tNgAGyN7XikIH3abqPtpO0bS85AgBsAdSQBqyJDARSJCTv+0qZwA8A3AbAJBP1eirN7ykSOoKE7qV5ggzcVVIZ8Hg8jSxen2ryMQTIHPgGAiKdANlpKhkCra2t9eXl5d8CaLNG4B4iPK4C7O7uro5EIiEISPneD4FDJUEA3UtZnABXgwb+S8DvSgWH3QN8G5PvyGsH68AJywkgm5sB/hHPJg3M6crKyp09PT1zBgQm+HYnz79TU1PV4+PjcUsIaLvM26Qc8kjVsWuRP0lk9xhtEZDYTUjsrAZYyJ3KE3ycMcdmZmbeMyJsuJUgqluYjBsVB3b0+hU13sH3ANGWBcipAkBCR8LhcFMgEIgYAUM+suq+lSdoI7NT8/PzO0dHR+fVxjQCVAk/ADtTwEVjsdgGwEdZpMIpbWd496L5Y9nAsQ/aCMlXsdGlli+XNRhu1YwPEsinsxIgUn9jUJsy+qTT6WwIBoNVOgHA/Ayh53p7e6XSJPNFcyl2KOIxfI3gMzg9PV2nSiktAxAI4mQNxoeJqkt1iISu0wkw4Da/33/6UgCttI9Woqe0fvVkYUYfIyMBDEYwdKvOpI4vLCzMyjczCSC/PbL50/w2ELhzOQnQ4Q0yIBVm6ScnLV5CZhPArw+fckCKIeWrqYKxnAQwGCYDrSoBl8u12uFwXLSAgERfsnCCoO7IOompQhe1Y98Qxm2qMamUuSFzxDQJaWuOyPZankMEdX9eBDAaxNijGnd1ddVytpUqZRoBgraVoP0oPlnQ7mb78WFeBOg0QAbaVWOq0Fqq0F8mE2gGy5viMxqN1g4PDy8qIOMc0CWEQT8Z6FCNvV7vOha0P80kwAQO4G8fzyR4blDxyL+NVuLFOUAb9n3LVmTI1dH2h5kE8KlfEIyhiAfzJmB0nnW73evZaS4uImasAy0tLTUVFRUXNNBuAjqSkwApkzovN2uvw9irdjCbABN4Lzg+zhYwo5V4kQBPWskyW0L4O4hknwTLHAuYk5KaWEkGXiMDT6gdLCCg3/B9gXx2p4I3nMS6hGjsoVO3VQSIdnkoFJojA1choxcIpn7XuoxHRgnJ3p1Okr6ln5kZQP+3gOE7cc7fxkznDSMCsmxX0+kVOj1lFQGC5SH6/fhPUPmcRmfsTBJaJMCTdvoxMwP40i/AzhBI/USWNg2yZeBlOj5jVQaYi+fxLXdMo8zFR40mcK4MvETHZ60goN8fyfUkC+YdHFuP501A2Qupfd6FzMOqhDINWODvPvweyDamkYT0yye13wXWkTrK2lp9L1RgoMuGI/By/fgi4P25/KQRYMd5DXt+KWFLbQx2njRONjc3V1RVVS07EeVysNJ2fIdramp+Uo+NK8rASh1abV+U/+Qzk9QVAmZG28jXf1bW3k/80G2uAAAAAElFTkSuQmCC');

    &.active {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAELklEQVRoQ+2ZTYwUVRCAq940rrqykNnp150Y4xHUaDiIcgA0IXogGw8aCULEgMaVnV4S9QghEPSkyRp2ehVEovwsGk0IIcQDCfHnBJJ4kCh4NP7M655hWVCBne0ui5/ByWz3dM9P78wk26fdvHr16ntVr6reG4Qu/7DL7Yc5gHZ7cNY84IzpK4BSmxj4PoH+sf6McwTXgNfsBswKgJsz1hLAYUAUFQb/iP70gD5c+LMZiMQBaAcIVzcuAeD8akOJ6CfZq57AjXCtUYjEAdzRzOMktB/CDGTP7DKy+e0dC6By8mWOnAOhBhJd0ucpiYNQagQicQ+onLkTEWrvMHor5ZD7fUcCODnzBFeb1TWNI7Cklbc7DmByX1/6+rV7FGcfrTYAfSAt9WbHATi2sZWzzzuRhpFvS8uxIuUCBBI7A1c+NORVH35lgAVRhnEm+ogz0eYouaDxxABixf5tixhgJwPs6BgA15ZvE4j34xqERIO6pfbGla+Ua7kH1Kh8AQV+yaETWzdLPq0P5b9tO4AzZr4IPo1HZp0qS1Pe1AP9Wy7+3nIAIkDX1lcgpQRp3qQu3HNhFdO1jZduNmx17Pz/BtMXvNT5MABBdL4H/j3ZZ10pVsuEupl2Q48rjK/YnoGKhSaR4A2O188rFU2MLFw4ddfdf7CyexvZxVhziKYJaI1hOUdjnQHHNm9UxqGZysnTBCxJb1bnymPcLg8Q4vFYhjQjRHQZ0L9fZt2/y2pCPaBs85/QHSXaz5Xz1QqAtQxwpBnb4s4VPq3KDKtTNQFuFSFUYUq5jz9tWGrZHYCb8Y/jcY1oSo68p6TlflcTwLF1EyD1V+hCBGe5+Vp6B2DUWEcC+QAn/2na9QfTgxO/dSUAZ7kCV2w98hDX7QFbrufKeyj5/afjMqueazmAsuUGBPHZLABsY4B3Ww7AjdsrfGn5NGkAIv9ZrgMnuxaAW44F3HJc7laACzKbX1zt5cBCVu8hno0Q4r7soGHlN3QtAAK9rmfVx8kAjJkbgWB/kodY+KWHMsPFGR1ri0LI2MRd6ycJAkxw/KeD9HcFAPdeR7n3ej45ANvgzhT3JeUBjv+3OP5HuhfAn17Kz/BnEwPgC81rfB+YkSFa4RFOn0WOf50v/tzLzfwCz0CM+8AZjskny+qS7IWiHr3Cb2Q5s8DU/UHUfKjGGWB9eYwL33K+PzT0uhzlJQGlhzPZ4i9hcqEATs7YxqlxV+BE9Fbzc/jX5bFbv8KYP/P/i6IMqmecN+oUb9SqWnPCXyX2wDy3JEcYgi/2tx+puB3kv7cEPYVfHDUeLSF+w5KB+boew2/IcuxPpYBWZix1uiGA8qTi7nQfCO0Rn0RPSqNC5WtEteL8e0av1kvPeCSWsAWPIWJjMEQKhbddHypciAKP/fwXpahd43MA7dr58rpzHmi3B/4DtK3hQD4hTzcAAAAASUVORK5CYII=');
    }
}
.submitButton {
    width: 28px;
    height: 28px;
    background-color: transparent;
    background-image: url('data:image/png;base64,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');
    border: none;
    outline: none;
}
</style>
